/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsFeedback_seller = {
    readonly serviceId: string | null;
    readonly orderFeedbackPdp: {
        readonly totalResults: number | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedDealerDetailsFeedback_seller";
};
export type PdpSharedDealerDetailsFeedback_seller$data = PdpSharedDealerDetailsFeedback_seller;
export type PdpSharedDealerDetailsFeedback_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsFeedback_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsFeedback_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsFeedback_seller",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackPdp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedbackPdp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();
(node as any).hash = '038c509aba68e8d52d1761a1c64925ff';
export default node;
